"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DASH = exports.SITE_NAME = void 0;
exports.SITE_NAME = '| Klubly';
exports.DASH = '–'; // This is an "en dash" not a minus sign
exports.default = {
    addToCalender: {
        appleCalender: 'Apple Calender',
        google: 'Google',
        outlook: 'Outlook',
        text: 'Zum Kalender hinzufügen',
    },
    appState: {
        appStartNoConnectionToServerNote: 'Es scheint ein Problem mit der Internetverbindung vorzuliegen.',
        restartAction: 'Die App wird neu gestartet',
        restartReason: 'Oh je... da hat sich ein Fehler in die App geschlichen. Sie muss deshalb neu gestartet werden. ' +
            'Wir beheben den Fehler so schnell wie möglich.',
        updateActionUpdateLater: 'Später',
        updateActionUpdateNow: 'Jetzt aktualisieren',
        updateAvailableBody: 'Aktualisiere jetzt deine App und schau dir die neuesten Funktionen an.',
        updatePermanentlyUnavailableBody: 'Leider ist für dein Telefon keine neue Version verfügbar.',
        updatePermanentlyUnavailableTitle: 'Version wird nicht unterstützt',
        updateRequiredBody: 'Bitte aktualisiere deine App, damit du wieder loslegen kannst.',
        updateRequiredTitle: 'Version wird nicht unterstützt',
        updateTemporarilyUnavailableBody: 'Wir arbeiten gerade auf unseren Servern. Bitte schau später wieder vorbei.',
        updateTemporarilyUnavailableTitle: 'Vorübergehend nicht erreichbar',
    },
    authentication: {
        agb1: 'Unsere ',
        agb2: 'Datenschutzerklärung',
        agb3: ' kannst du ',
        agb4: 'hier',
        agb5: ' einsehen.',
        ageConfirmation1: 'Hiermit stimme ich den ',
        ageConfirmation2: 'Nutzungsbedingungen',
        ageConfirmation3: ' zu.',
        ageConfirmationError: 'Bitte stimme unseren Nutzungsbedingungen zu.',
        alreadyRegistered: 'Ich habe schon ein Profil',
        confirmPasswordReset: 'Passwort zurücksetzen',
        errorAddress: 'Bitte überprüfe deine Adresse.',
        errorAutomaticLoginModalBody: 'Schön, dass du wieder da bist. 🤗 Melde dich jetzt einfach wieder an. ',
        errorLogin: 'Deine Zugangsdaten sind nicht richtig.',
        errorLoginModalBody: 'Bitte überprüfe deine E-Mail-Adresse und dein Passwort.',
        errorLoginModalTitle: 'Anmeldung fehlgeschlagen',
        errorMissingEmail: 'Bitte gib deine E-Mail-Adresse ein.',
        errorMissingPassword: 'Bitte gib dein Passwort ein.',
        errorOAuthLoginUserDeniedAuthorization: 'Zugriff verweigert.',
        errorOAuthLoginUserNotRegistered: 'Bitte registriere dich zuerst, damit du dich anmelden kannst.',
        errorPassword: 'Bitte überprüfe dein Passwort.',
        errorPasswordReset: 'Wir konnten dir leider keine E-Mail schicken. ' +
            'Bitte versuche es später noch einmal.',
        errorRepeatPassword: 'Die eingegebenen Passwörter stimmen nicht überein.',
        facebookRegistrationEmailSubTitle: 'Bitte gib deine E-Mail-Adresse ein:',
        facebookRegistrationEmailTitle: 'E-Mail-Adresse fehlt',
        internetConnectionProblemBody: 'Bitte überprüfe deine Internetverbindung und versuche es noch einmal.',
        internetConnectionProblemTitle: 'Keine Internetverbindung',
        loginTitle: 'Schön, dass du wieder da bist!',
        loginWithApple: 'Mit Apple anmelden',
        loginWithFacebook: 'Mit Facebook anmelden',
        newPassword: 'Neues Passwort',
        newPasswordRepeat: 'Neues Passwort wiederholen',
        passwordChanged: 'Dein Passwort wurde erfolgreich geändert.',
        passwordChangedLongText: 'Du kannst dich ab sofort mit deiner E-Mail-Adresse und deinem neuen Passwort anmelden.',
        passwordForgot: 'Passwort vergessen?',
        passwordForgotBody: 'Das kann jedem mal passieren… Gib einfach unten deine E-Mail-Adresse ein, ' +
            'dann schicken wir dir eine E-Mail zum Zurücksetzen deines Passwortes.',
        passwordResetTitle: 'Passwort zurücksetzen?',
        registerLopo: 'Jetzt bei deinem Vereinsportal registrieren',
        registerNow: 'Jetzt kostenlos registrieren',
        registerWithApple: 'Mit Apple registrieren',
        registerWithFacebook: 'Mit Facebook registrieren',
        repeatPassword: 'Passwort wiederholen',
        resetConfirmationBody: 'Wir haben dir eine E-Mail gesendet. Bitte folge dem Link in der E-Mail, ' +
            'um dein Passwort zurückzusetzen.',
        resetConfirmationTitle: 'Du hast Post!',
        sendEmail: 'E-Mail senden',
        wantRegister: 'Ich möchte mich registrieren',
    },
    blacklist: {
        blacklist: 'Blockieren',
        forEver: 'Für immer',
        modalContent: 'Wenn du einen Nutzer blockierst, könnt ihr eure Beiträge gegenseitig nicht mehr im Newsfeed ' +
            'sehen und euch keine privaten Nachrichten mehr senden. In deinen Einstellungen unter „Blockierte ' +
            'Nutzer” kannst du diesen Vorgang jederzeit rückgängig machen.',
        modalTitle: 'Blockieren bestätigen',
        modalTitleRemove: 'Blockierte Nutzer',
        profile: 'Nutzer blockieren',
        revertBlacklist: 'Nutzer nicht mehr blockieren',
        wizardExplanation: 'Hier siehst du deine blockierten Nutzer. ' +
            'Mit einem Klick auf den Kreis kannst du diese Einstellung rückgängig machen.',
        wizardHeaderText: 'Blockierte Nutzer',
    },
    comments: {
        attachImage: 'Bilder hinzufügen',
        comment: 'Kommentieren',
        commentCount: (count) => `${count} ${count === 1 ? 'Kommentar' : 'Kommentare'}`,
        disabled: 'Kommentare wurden deaktiviert',
        discardChanges: 'Änderungen verwerfen',
        edit: 'Kommentar bearbeiten',
        editCancel: 'Bearbeiten des Kommentars abbrechen',
        editCancelAlert: 'Möchtest du deine Änderungen wirklich verwerfen?',
        editCancelCTA: 'abbrechen',
        editCancelText: 'Bearbeiten des Kommentars',
        editError: 'Dein Kommentar konnte nicht bearbeitet werden. Versuche es bitte noch einmal.',
        edited: (date) => `(Bearbeitet – ${date})`,
        nonYetMessage: 'Erzähle, was du über diesen Beitrag denkst.',
        noneYet_APP: 'Hier gibt es bisher noch keine Kommentare.',
        noneYet_WEB: 'Bisher noch keine Kommentare',
        placeHolder_APP: 'Dein Kommentar',
        placeHolder_WEB: 'Schreibe einen Kommentar',
        remove: 'Kommentar löschen',
        removeError: 'Dein Kommentar konnte nicht gelöscht\nwerden. Versuche es bitte noch einmal.',
        removedByAdmin_APP: 'Dieser Kommentar wurde von einem Administrator gelöscht.',
        removedByAdmin_WEB: 'Dieser Kommentar wurde von einem Moderator gelöscht.',
        removedByAuthor: 'Dieser Kommentar wurde von seinem Autor gelöscht.',
        removedByCommentableAuthor_APP: 'Dieser Kommentar wurde vom Autor des Beitrags gelöscht.',
        removedByCommentableAuthor_WEB: 'Dieser Kommentar wurde vom Autor des zugehörigen Beitrages gelöscht.',
        removedByUnknown: 'Dieser Kommentar wurde gelöscht.',
        submit: 'Kommentar absenden',
        submitError: 'Dein Kommentar konnte nicht gesendet\nwerden. Versuche es bitte noch einmal.',
        sureToRemove: 'Bist du dir sicher, dass du diesen Kommentar löschen möchtest?',
        total: 'Insgesamt',
        update: 'Kommentar aktualisieren',
        write: 'Schreibe einen Kommentar',
    },
    cookieConsent: {
        linkText: 'Verwendung von Cookies zu.',
        message: 'Um dir ein besseres Nutzungserlebnis zu bieten, verwenden wir Cookies. ' +
            'Durch die Nutzung deines Vereinsportals stimmst du der ',
    },
    createFlag: {
        messagePlaceholder: 'Teile uns deine Bedenken mit.',
        reason: 'Grund',
        submitTitle: 'Dein Beitrag wurde gemeldet',
        successText: 'Du hast den Beitrag erfolgreich gemeldet. Wir werden ihn sobald wie möglich prüfen. Vielen Dank!',
        text: 'Du hast Bedenken über den Inhalt dieses Beitrags?' +
            ' Dann kannst du den Beitrag hier melden und wir prüfen ihn so bald wie möglich.' +
            ' Der Verfasser des Beitrags wird über die Meldung nicht informiert.',
        title: 'Beitrag melden',
    },
    dateFormat: {
        around: (prefix, date) => `${prefix}, ${date}`,
        at: 'um',
        between: (from, to) => `${from} - ${to}`,
        clock: 'Uhr',
        eventFeed: 'dd. DD.MM.YYYY',
        eventFeedHeaderLong: 'ddd, DD. MMMM YYYY',
        eventFeedHeaderRangeLong: 'DD. MMM YYYY',
        eventFeedHeaderRangeShort: 'DD. MMM',
        eventFeedHeaderShort: 'DD. MMMM YYYY',
        from: 'von',
        // will be used for relative times like "In 10 Minuten"
        future: (relTime) => `In ${relTime}`,
        // will be used if the relative time is less than 45 seconds in the past
        // (see https://momentjs.com/docs/#/customization/relative-time-threshold/)
        justNow: 'Gerade eben',
        last: 'Letzten',
        onTheWeekend: 'Am Wochenende',
        ongoing: 'Findet gerade statt',
        // will be used for relative times like "Vor 10 Minuten"; special handling for the
        // "just now" case, see definition of property 's' below
        past: (relTime) => relTime === 'Gerade eben' ? 'Gerade eben' : `Vor ${relTime}`,
        short: 'DD.MM.YYYY',
        timeOnly: 'H:mm [Uhr]',
        tiny: 'DD.MM.YY',
        to: 'bis',
        today: 'Heute',
        tomorrow: 'Morgen',
        withDayOfWeekLong: 'dddd, DD. MMM YYYY',
        withDayOfWeekShort: 'dddd, DD.MM.YYYY',
        yesterday: 'Gestern',
    },
    datePicker: {
        buttonOK: 'Übernehmen',
        buttonReset: 'Zurücksetzen',
        selectEndDate: 'Zeitraum auswählen und ',
        shortFriday: 'Fr',
        shortMonday: 'Mo',
        shortSaturday: 'Sa',
        shortSunday: 'So',
        shortThursday: 'Do',
        shortTuesday: 'Di',
        shortWednesday: 'Mi',
    },
    emojiMart: {
        activity: 'Aktivität',
        custom: 'Vereinsportal',
        flags: 'Flaggen',
        foods: 'Essen & Trinken',
        nature: 'Tiere & Natur',
        notfound: 'Keine Ergebnisse',
        objects: 'Gegenstände',
        people: 'Emojis & Personen',
        places: 'Reisen & Orte',
        recent: 'Letzte',
        search: 'Suche',
        symbols: 'Symbole',
    },
    eventParticipants: {
        deleteModalBody: 'Möchtest du wirklich nicht mehr an der Veranstaltung teilnehmen?',
        deleteModalButton: 'Nicht mehr teilnehmen',
        deleteModalTitle: 'Nicht mehr teilnehmen?',
        iWantToParticipate: 'Ich möchte teilnehmen',
        imParticipating: 'Ich nehme teil',
        justYou: 'Du nimmst teil',
        participants: 'Teilnehmer',
        showParticipantsList: 'Teilnehmerliste anzeigen',
        you: 'Du',
    },
    eventfeed: {
        feedLoadingError: 'Die Veranstaltungen konnten nicht geladen werden.',
        freeDateChoice: 'Frei wählbar',
        itemLoadingError: 'Diese Veranstaltung konnte nicht geladen werden',
        myEvents: 'Meine Veranstaltungen',
        noEventsAvailable: 'Für diesen Zeitraum gibt es leider noch keine Veranstaltungen.',
        relatedContentSubtitle: 'Das ist in den nächsten Tagen bei dir los.',
    },
    feedback: {
        acceptAndSubmit: 'Zustimmen und senden',
        emailPlaceholder: 'Deine E-Mail-Adresse',
        errorInputRequired: 'Bitte gib dein Feedback ein.',
        errorSending: 'Ups... Dein Feedback konnte nicht gesendet werden.',
        message: 'Dir ist ein Fehler aufgefallen, du hast neue Ideen oder Fragen? ' +
            'Dann schreibe uns gerne eine Nachricht.',
        messagePlaceholder: 'Dein Feedback',
        onboardingErrorFeedbackPlaceholder: 'Damit wir unser Vereinsportal stets verbessern können, ' +
            'freuen wir uns über deine Nachricht.',
        onboardingErrorFeedbackTitle: 'Es tut uns Leid, da ist etwas schiefgelaufen.' +
            '\nBitte sende uns dein Feedback, damit wir das Problem so schnell wie möglich lösen können.',
        terms: 'Ich stimme der Speicherung meiner Daten zur Bearbeitung und Beatwortung meiner Anfrage sowie ' +
            'möglicher Anschlussfragen zu. Dem kann ich jederzeit widersprechen. Hierzu genügt eine E-Mail an: ' +
            'info@klubly.de',
        thanksMessage: 'Danke für dein Feedback! Wir werden uns so schnell wie möglich bei dir melden. ' +
            ' ',
        thanksMessageLink: '',
        thanksTitle: 'Vielen Dank!',
        title: 'Hilf uns mit deinem Feedback',
    },
    follow: {
        follow: 'Folgen',
        followAlertMessage: (profileName) => `Du folgst „${profileName}” jetzt.`,
        following: 'Abonniert',
        noFollowersMessage: 'Das kannst du ganz schnell ändern! Stelle dich vor, ' +
            'halte deinen Verein auf dem Laufenden und erzähle auch Freunden und Bekannten von deinem Profil. ' +
            'Dann wird hier schon bald der Bär steppen.',
        noFollowersTitle: 'Noch keine Abonnenten in Sicht? 👀 🔍',
        showFollowers: 'Abonnenten anzeigen',
        turnOffNotifications: 'Benachrichtigungen ausschalten',
        turnOnNotifications: 'Benachrichtigungen einschalten',
        unfollow: 'Nicht mehr abonnieren',
        unfollowAlertBody: (profileName) => `Wenn du ${profileName} nicht mehr abonnierst, ` +
            'erhältst du keine Benachrichtigungen mehr zu den Neuigkeiten des Nutzers und ' +
            'findest sie nicht mehr auf den allerersten Blick auf deiner Startseite.',
        unfollowAlertTitle: 'Nicht mehr abonnieren?',
    },
    graylist: {
        graylist: 'Stumm geschaltet 🤐',
        modalTitle: 'Stumm geschaltete Profile 🤐',
        mute: 'Stumm schalten',
        remainingDays: (days) => `Noch ${days === 1 ? '1 Tag' : `${days} Tage`}`,
        revertGraylist: 'Profil nicht mehr stumm schalten',
        successMessage: (profileName, durationInDays) => `Beiträge von „${profileName}“ werden nun ${durationInDays === 1 ? '1 Tag' : `${durationInDays} Tage`} ` +
            'nicht mehr angezeigt. Dies kannst du in den Einstellungen ändern.',
        wizardExplanation: 'Hier siehst du alle Profile, die du stumm geschaltet hast. Mit ' +
            'einem Klick auf den kleinen Lautsprecher kannst du diese Einstellung rückgängig machen.',
        yet: 'Noch',
    },
    groups: {
        confirmMember: 'Gruppenmitglied hinzufügen',
        confirmMemberFail: (name) => `Beim Hinzufügen des Gruppenmitglieds "${name}" ist ein Fehler aufgetreten.`,
        confirmMemberSuccess: (name) => `Du hast das Gruppenmitglied "${name}" hinzugefügt.`,
        confirmations: {
            accept: {
                body: 'Bist du dir sicher, dass du diesen Benutzer akzeptieren möchtest?',
                buttonConfirm: 'Bestätigen',
                title: 'Akzeptieren bestätigen',
            },
            reject: {
                body: 'Bist du dir sicher, dass du diesen Benutzer ablehnen möchtest?',
                buttonConfirm: 'Bestätigen',
                title: 'Ablehnen bestätigen',
            },
            remove: {
                body: 'Bist du dir sicher, dass du dieses Mitglied entfernen möchtest?',
                buttonConfirm: 'Bestätigen',
                title: 'Entfernen bestätigen',
            },
        },
        confirmedUsers: 'Gruppenmitglieder',
        ctaBlocked: {
            buttonLabel: 'Zum Newsfeed',
            info: 'Der Zugang zu Gruppen ist nur für Vereinsmitglieder möglich. ' +
                'Wechsel einfach in dein privates Profil.',
            title: 'Nur für Nutzer',
        },
        ctaNotJoinedFeed: {
            infoCanJoin: 'Tritt dieser Gruppe bei, wenn du dich mit anderen Nutzern darüber austauschen möchtest.',
            infoCanNotJoin: 'Du kannst dieser Gruppe leider nicht beitreten, weil sie außerhalb deiner Region liegt.',
            infoLoggedOut: 'Registriere dich jetzt und tritt dieser Gruppe bei, wenn du ' +
                'dich mit anderen Nutzern darüber austauschen möchtest.',
            title: 'Klingt interessant?',
        },
        ctaNotJoinedMembers: {
            infoCanJoin_APP: (groupName) => `Sobald du der Gruppe ${groupName} beigetreten bist, kannst du die anderen Gruppenmitglieder ` +
                'sehen und dich mit ihnen austauschen.',
            infoCanJoin_WEB: 'Sobald du der Gruppe beigetreten bist, kannst du die anderen Gruppenmitglieder ' +
                'sehen und dich mit ihnen austauschen.',
            infoCanNotJoin: 'Du kannst die Gruppenmitglieder dieser Gruppe leider nicht sehen, ' +
                'weil sie außerhalb deiner Region liegt.',
            title_APP: 'Du bist noch kein Mitglied dieser Gruppe.',
            title_WEB: (groupName) => `Möchtest du der Gruppe „${groupName}” beitreten?`,
        },
        ctaRecommendation: {
            body: 'Du bist ein großer Ernährungs-Fan oder möchtest dich mit deinen Freunden über ' +
                'die aktuellsten Sportthemen austauschen? Oder interessierst du dich für die ehrenamtliche Mitarbeit und möchtest ' +
                'das nächste Spiel-Catering unkompliziert organisieren? Schlage jetzt deine Gruppe vor! Fülle ' +
                'die Felder aus und sende deinen Vorschlag ab. Wir melden uns danach so schnell wie möglich bei dir zurück.',
            groupDescriptionInput: 'Beschreibe deine Gruppe',
            groupNameInput: 'Name der Gruppe',
            header: 'Gruppe vorschlagen',
            title: 'Dein Lieblingsthema ist noch nicht dabei?',
        },
        eliminateMember: 'Gruppenmitglied entfernen',
        eliminateMemberFail: (name) => `Beim Entfernen des Gruppenmitglieds "${name}" ist ein Fehler aufgetreten.`,
        eliminateMemberSuccess: (name) => `Du hast das Gruppenmitglied „${name}“ entfernt.`,
        groupNotFoundError: 'Diese Gruppe wurde nicht gefunden.',
        groups: 'Gruppen',
        groupsInMyRegion: 'Gruppen meines Vereins',
        inviteNeighborSubtitle: 'Füge Mitglieder und Freunde hinzu',
        inviteNeighborTitle: 'Lade deine Freunde ein',
        joinClosedGroupError: (groupName) => `Beim Anfragen an die Gruppe ${groupName} ist ein Fehler aufgetreten.`,
        joinClosedGroupModal: {
            confirm: 'Anfragen',
            message: 'Hiermit stellst du eine Beitrittsanfrage an diese private Gruppe, welche von einem Administrator ' +
                'bearbeitet wird. Sobald du angenommen wurdest, kannst du Beiträge sehen und erstellen.',
            title_APP: (groupName) => `Möchtest du „${groupName}“ beitreten?`,
            title_WEB: (groupName) => `Möchtest du „${groupName}“ beitreten?`,
        },
        joinClosedGroupSuccess: (groupName) => `Deine Anfrage an die Gruppe "${groupName}" wurde abgeschickt.`,
        joinGroup: 'Beitreten',
        joinGroupError: (groupName) => `Beim Beitreten der Gruppe ${groupName} ist ein Fehler aufgetreten.`,
        joinGroupSuccess: (groupName) => `Du bist jetzt Mitglied der Gruppe „${groupName}“.`,
        leaveGroup: 'Gruppe verlassen',
        leaveGroupError: (groupName) => `Beim Verlassen der Gruppe ${groupName} ist ein Fehler aufgetreten.`,
        leaveGroupModal: {
            confirm: 'Verlassen',
            message: 'Wenn du die Gruppe verlässt, kannst du Beiträge in dieser Gruppe nicht mehr sehen. ' +
                'Du erhältst außerdem keine Benachrichtigungen mehr darüber, was in der Gruppe passiert.',
            title_APP: (groupName) => `„${groupName}“ wirklich verlassen?`,
            title_WEB: (groupName) => `Möchtest du die Gruppe „${groupName}“ wirklich verlassen?`,
        },
        leaveGroupSuccess: (groupName) => `Gruppe erfolgreich verlassen ${groupName}.`,
        loadGroupError: 'Die Gruppe konnte nicht geladen werden.',
        memberCount: (count) => `${count} ${count === 1 ? 'Mitglied' : 'Mitglieder'}`,
        memberCountHeader: (count) => `${count} Gruppenmitglieder`,
        memberListAdminSection: 'Administratoren',
        memberListMemberSection: 'Gruppenmitglieder',
        moreGroups: 'Weitere Gruppen',
        moreGroupsEmpty: 'Hier gibt es leider noch keine Gruppen.',
        myGroups: 'Deine Gruppen',
        notifications: {
            changeError: `Ein Fehler ist aufgetreten. Bitte später erneut versuchen.`,
            changeSuccess: (groupName, enabled) => `Die Benachrichtigungen für die Gruppe ${groupName} sind ${enabled ? 'eingeschaltet' : 'ausgeschaltet'}.`,
            label: 'Benachrichtigungen',
        },
        pending: 'Deine Anfrage muss erst von einem Administrator angenommen werden, bevor du Beiträge sehen und ' +
            'erstellen kannst.',
        pendingGroups: 'Anstehende Gruppen',
        pendingUsers: 'Anstehende Benutzer',
        recommendationSubtitle: 'Schlage eine neue Gruppe vor',
        recommendationSuccessBody: 'Wir geben unser Bestes, dir so schnell wie möglich zu antworten.',
        recommendationSuccessTitle: 'Dein Vorschlag ist \nauf dem Weg zu uns',
        recommendationTitle: 'Dein Lieblingsthema fehlt?',
        sendRecommendationBody: (title, description) => `Anfrage: Neue Gruppe \nTitel: ${title} \nBeschreibung: ${description}`,
        shareGroup: 'Gruppe teilen',
        shareGroupMessage: 'Schau mal! Ich habe diese Gruppe in meinem Vereinsportal gefunden, ' +
            'die auch für dich interessant sein könnte.',
        showMemberList: 'Gruppenmitglieder anzeigen',
    },
    header: {
        events: 'Veranstaltungen',
        groups: 'Gruppen',
        mainPage: 'Startseite',
        notifications: 'Benachrichtigungen',
        profilesDirectory: 'Suche',
    },
    imageAlt: {
        addImage: 'Bild hinzufügen',
        addedMedia: 'Hinzugefügte Medien',
        avatar: 'Avatar',
        campaignLoading: 'Kampagne lädt',
        campaignSuccess: 'Kampagnenerfolg',
        contactPerson: 'Ansprechpartner',
        headerImage: 'Bild Kopfzeile',
        imageCropper: 'Bild zuschneiden',
        linkPreview: 'Link Vorschau',
        loadingSpinner: 'Ladefortschritt',
        markerImage: 'Kartenmarkierung',
        poweredByGoogle: 'Unterstützt von Google',
        snapshotPreview: 'Schnappschuss Vorschau',
        staticMap: 'Karte',
        success: 'Erfolg',
    },
    intermediateProfile: {
        completeProfile: {
            body: 'Vervollständige jetzt noch dein Profil, damit du alle Funktionen deines Vereinsportals nutzen kannst.',
            bodyTitle: 'Gleich geschafft...',
            title: 'Profil vervollständigen',
        },
        confirmEmail: {
            body1: 'Bitte bestätige deine E-Mail-Adresse ',
            body2: '. Schau auch mal in deinem Spam-Ordner nach, falls du sie nicht findest. ' +
                'Bei Problemen schreibe uns gerne eine Nachricht an ',
            bodyTitle: 'Schau in dein Postfach...',
            buttonText: 'Bestätigungsmail erneut senden',
            title: 'E-Mail bestätigen',
        },
        register: {
            body: 'Registriere dich jetzt, und schon kannst du die Beiträge deines Vereins lesen ' +
                'und dich austauschen.',
            bodyTitle: 'Hereinspaziert',
            loginButton: 'Anmelden',
            registerButton: 'Jetzt registrieren',
            title: 'Vereinsportal',
        },
        verify: {
            body: 'Erst wenn du dich verifiziert hast, kannst du dich mit deinem Verein ' +
                'austauschen.',
            bodyTitle: 'Mach jetzt mit!',
            button: 'Jetzt verifizieren',
            title: 'Profil verifizieren',
        },
    },
    item: {
        deletePost: 'Beitrag löschen',
        deletePostConfirmationQuestion: 'Möchtest du den Beitrag wirklich löschen?',
        duplicatePost: 'Beitrag duplizieren',
        editPost: 'Beitrag bearbeiten',
        keepAddress: 'Adresse übernehmen',
        notFound: 'Ups... der Beitrag ist leider\nnicht mehr vorhanden.',
        notFoundTitle: 'Beitrag nicht gefunden',
        snapshotUpdatingError: 'Der Schnappschuss konnte nicht bearbeitet werden.',
        updatingError: 'Der Beitrag konnte nicht aktualisiert werden.',
    },
    landingPage: {
        info: 'In deinem Vereinsportal erfährst du auf einen Blick, was es Neues gibt.',
        learnMore: 'Mehr erfahren',
        notFound: 'Die Seite wurde leider nicht gefunden :(',
        return: 'Zurück zu deinem Vereinsportal',
        title: 'Was gibt\'s Neues im Verein?',
    },
    locationChanger: {
        addressNotFound: 'Bitte gib die vollständige Adresse mit Straße und Ort ein!',
        areaNotReleased: 'Der eingegebene Ort ist noch nicht freigeschaltet. Bitte gib einen anderen Ort ein!',
        areaNotReleasedAlertBody: 'Leider ist Klubly in dieser Region noch nicht verfügbar.',
        areaNotReleasedAlertTitle: 'Wir sind noch nicht vor Ort',
        areaNotReleasedShort: 'Dieser Ort ist leider noch nicht freigeschaltet.',
        brokenAddress: 'Ungültige Adresse',
        currentLocation: 'Aktueller Standort',
        defaultError: 'Der eingegebene Ort ist ungültig. Bitte gib einen anderen Ort ein!',
        enableGeolocationInfo: 'Erlaube uns zuerst den Zugriff auf deinen Standort. ' +
            'Gehe dafür einfach in deine Einstellungen.',
        fetchLocationError: 'Dein Standort konnte nicht ermittelt werden.',
        headerLocationChanger: 'Ort wählen',
        homeLocation: 'Meine Adresse',
        inputPlaceholder: 'Adresse oder Ort',
        invalidParameters: 'Bitte versuche es erneut, oder gib einen anderen Ort ein!',
        outOfReach: 'Der eingegebene Ort liegt außerhalb des erlaubten Bereichs. Bitte gib einen anderen Ort ein!',
        outOfReachBody: 'Der Ort liegt außerhalb des erlaubten Bereichs.',
        outOfReachTitle: 'Bitte gib einen anderen Ort ein!',
        popularPlaces: 'Beliebte Orte',
        removeAddress: 'Adresse entfernen',
        searchResults: 'Suchergebnisse',
        updatingFeedLocation: 'Dein Standort wird aktualisiert.',
    },
    mailbox: {
        goBackButtonTitle: 'Zurück zum Postfach',
        homepage: 'STARTSEITE',
        loadMoreMessages: 'Vorherige Nachrichten laden',
        mailBox: 'Postfach',
        moreMessages: 'weitere Nachrichten',
        noConversationSelected: 'Kein Gespräch ausgewählt',
        replyPlaceholder: 'Schreibe eine Antwort',
        sendMessageWithNeighbors: 'Tausche dich mit deiner Community aus',
    },
    mainMenu: {
        appAnnouncement: 'Neues in der App',
        conversations: 'Postfach',
        conversationsNotAvailableBody: 'Private Nachrichten kannst du in der App leider zurzeit noch nicht lesen.',
        conversationsNotAvailableTitle: 'Postfach nicht verfügbar',
        createBlog: 'Profil hinzufügen',
        setTheme: 'Wähle einen Farbmodus',
        setThemeButton: 'Farbmodus',
        spread: 'Freunde einladen',
        themeDark: 'Nacht',
        themeLight: 'Tag',
        themeSystem: 'Systemeinstellung',
        toProfile: 'Mein Profil',
    },
    manageBlogProfileAdmin: {
        formBodyEnd: ' helfen kann, ' +
            'muss er selbst als Nutzer im Vereinsportal registriert sein.\n\n' +
            'Sobald du deine Anfrage abgeschickt hast, kann es ein kleines bisschen dauern, ' +
            'bis der Administrator deinem Profil hinzugefügt wird. ' +
            'Wir kümmern uns aber so schnell wie möglich darum. 👩‍🔧👷‍♂️',
        formBodyStart: 'Bevor jemand dir beim Verwalten deines Profils ',
        formSuccessBodyEnd: ' als Administrator hinzugefügt haben. ' +
            'Bei Fragen sende uns einfach eine Nachricht an: ',
        formSuccessBodyStart: 'Deine Anfrage wurde ans Support-Team geschickt. ' +
            'Wir melden uns so schnell wie möglich per E-Mail bei dir, sobald wir ',
        formSuccessTitle: 'Juhu... bald könnt ihr zusammen arbeiten!',
        menuDescription: 'Profil mit mehreren Nutzern verwalten',
        menuName: 'Administrator hinzufügen',
    },
    map: {
        expandButtonTooltip: 'Vollbild',
        failedGetLocationError: 'Huch, wo bist du denn da gelandet? Wir haben dich zurück an Land gebracht.',
        homeButtonTooltip: 'Zum Vereinsportal',
        locateMeButtonTooltip: 'Zum aktuellen Standort',
        locationChangerButtonTooltip: 'Standort wechseln',
        searchThisArea: 'In diesem Bereich entdecken',
        zoomInButtonTooltip: 'Vergrößern',
        zoomOutButtonTooltip: 'Verkleinern',
    },
    metatags: {
        defaultTag: {
            author: 'Klubly',
            copyright: 'Klubly, Berlin, Germany',
            description: 'Klubly ist die Kommunikationsplattform für deinen Sportverein. Tausche dich mit ' +
                'deinen Vereinsfreunden aus und erfahre auf einen Blick, was es Neues im Verein gibt.',
            email: 'info@klubly.de',
            siteName: 'Klubly',
            title: 'Klubly – die Kommunikationsplattform für deinen Sportverein',
        },
        descriptions: {
            eventsfeed: (locationName) => `Alle Veranstaltungen in ${locationName}. ` +
                'Bleibe auf dem Laufenden über Veranstaltungen deines Vereins.',
            groupOverview: 'Du suchst Gleichgesinnte, mit denen du deine Lieblingsthemen oder deine Interessen ' +
                'teilen kannst? In unseren Gruppen kannst du dich mit deinen Vereinsfreunden zu bestimmten Themen austauschen.',
            newsfeedAdditionalPage: (startIndex, endIndex, locationName) => `Beiträge ${startIndex} bis ${endIndex} ${exports.DASH} ` +
                `Alle Neuigkeiten und Informationen aus ${locationName} und ` +
                'Vereinsportal – direkt aus deinem Verein.',
            newsfeedFirstPage: (locationName) => `Alle Neuigkeiten und Informationen aus ${locationName} und ` +
                'Vereinsportal – direkt aus deinem Verein.',
            profilesDirectory: (locationName) => `Finde Leute aus deinem Verein.${locationName}`,
            profilesDirectoryCategoryAuthorityProfiles: (locationName) => `Finde Partner & Sponsoren ${locationName}`,
            profilesDirectoryCategoryPressProfiles: (locationName) => `Finde Abteilungen. ${locationName}`,
            profilesDirectoryCategoryPrivateProfiles: (locationName) => `Finde Vereinsfreunde. ${locationName}`,
            shapeSponsors: 'Werde jetzt zum Partner und dein Profil ' +
                'erhält noch mehr Sichtbarkeit – direkt auf der Startseite.',
        },
        titles: {
            categorizedEventsfeed: (locationName, category) => `Veranstaltungen ${exports.DASH} ` +
                `${category} ${exports.DASH} ${locationName} ${exports.SITE_NAME}`,
            createProfile: `Profil hinzufügen ${exports.SITE_NAME}`,
            detailsPage: (title) => `${title} ${exports.SITE_NAME}`,
            eventParticipating: `Meine Veranstaltungen ${exports.SITE_NAME}`,
            eventParticipations: `Teilnehmerliste ${exports.SITE_NAME}`,
            eventsfeed: (locationName) => `Veranstaltungen ${exports.DASH} Übersicht ${exports.DASH} ${locationName} ${exports.SITE_NAME}`,
            groupFeed: (groupName) => `${groupName} ${exports.SITE_NAME}`,
            groupMembers: (groupName) => `${groupName} ${exports.DASH} Mitglieder ${exports.SITE_NAME}`,
            groupOverview: (locationName) => `Gruppen ${exports.DASH} Übersicht ${exports.DASH} ${locationName} ${exports.SITE_NAME}`,
            locationPicker: `Verein auswählen ${exports.SITE_NAME}`,
            login: `Anmelden ${exports.SITE_NAME}`,
            mailbox: `Postfach ${exports.SITE_NAME}`,
            newsfeedAdditionalPage: (locationName, currentPage, totalPages) => `Seite ${currentPage}/${totalPages} ${exports.DASH} Aktuelles aus ${locationName} ${exports.SITE_NAME}`,
            newsfeedAdditionalPageIn: (place, currentPage, totalPages) => `Seite ${currentPage}/${totalPages} ${exports.DASH} Aktuelles vom ${place}`,
            newsfeedFirstPage: (locationName) => `Aktuelles aus ${locationName} ${exports.SITE_NAME}`,
            newsfeedFirstPageIn: (place) => `Aktuelles vom ${place}`,
            notFound: 'Die Seite wurde leider nicht gefunden',
            notifications: `Benachrichtigungen ${exports.SITE_NAME}`,
            privateProfile: `Privates Profil ${exports.SITE_NAME}`,
            profile: (name) => `${name} ${exports.SITE_NAME}`,
            profileFollowers: `Abonnenten ${exports.SITE_NAME}`,
            profilesDirectory: (locationName) => `Entdecke ${locationName} ${exports.SITE_NAME}`,
            profilesDirectoryCategoryAuthorityProfiles: (locationName) => `Partner & Sponsoren ${locationName} ${exports.SITE_NAME}`,
            profilesDirectoryCategoryAuthorityProfilesIn: (place) => `Partner & Sponsoren in ${place}`,
            profilesDirectoryCategoryPressProfiles: (locationName) => `Deine Abteilungen ${locationName} ${exports.SITE_NAME}`,
            profilesDirectoryCategoryPressProfilesIn: (place) => `Deine Abteilungen in ${place}`,
            profilesDirectoryCategoryPrivateProfiles: (locationName) => `Deine Vereinsfreunde. ${locationName} ${exports.SITE_NAME}`,
            profilesDirectoryCategoryPrivateProfilesIn: (place) => `Deine Vereinsfreunde in ${place}`,
            profilesDirectoryIn: (place) => `Entdecke ${place}`,
            recentFolloweesFeed: `Profilbeiträge ${exports.SITE_NAME}`,
            recentGroupsFeed: `Gruppenbeiträge ${exports.SITE_NAME}`,
            registration: `Registrieren ${exports.SITE_NAME}`,
            resetPassword: `Passwort zurücksetzen ${exports.SITE_NAME}`,
            settings: `Einstellungen ${exports.SITE_NAME}`,
            shapeSponsors: `Partner des Vereins ${exports.SITE_NAME}`,
            topicChat: `Chat ${exports.SITE_NAME}`,
        },
    },
    neighborChat: {
        isTyping: 'schreibt ...',
        joinChat: 'Chat beitreten',
        messagesTitle: 'Chat',
        neighborsOnline: (count) => `${count} ${count === 1 ? 'Nutzer ist' : 'Nutzer sind'} online`,
        neighborsTitle: 'Gerade online',
        showNeighbors: 'Nutzer anzeigen',
    },
    newUserInfoCTA: {
        body: 'Tausche dich mit Vereinsfreunden aus. ' +
            'Erhalte Neuigkeiten aus deinem Verein. ' +
            'Entdecke die neusten Veranstaltungen.',
        title: 'Was gibt\'s Neues in deinem Verein?',
    },
    newsfeed: {
        highlights: {
            allFollowewPosts: 'Beiträge abonnierter Profile',
            allGroupPosts: 'Weitere Gruppenbeiträge',
            moreFolloweePosts: 'Weitere Beiträge von abonnierten Profilen',
            moreGroupPosts: 'Weitere Beiträge aus deinen Gruppen',
            mostInteracted: (locationShapeName) => `Darüber spricht ${locationShapeName}`,
            mostViewed: (locationShapeName) => `Das interessiert ${locationShapeName}`,
            newsFromTheLast24Hours: 'Neues aus den letzten 24 Stunden',
            recentFolloweePostsTitle: 'Abonniert: ',
            recentGroupPostsTitleFallback: 'Gruppe',
        },
        loadingError: 'Die Beiträge konnten nicht geladen werden.',
        moreItemsInPostGroup: (count) => `${count}` + (count === 1 ? ' weiterer Beitrag' : ' weitere Beiträge') + ' von diesem Nutzer',
        noNewsAvailable: 'Hier gibt es bisher noch keine Beiträge.',
    },
    notification: {
        defaultInitiatorName: 'Ein Mitglied',
        eventParticipationEnd: 'teil.',
        eventParticipationStart: 'nimmt an deiner Veranstaltung',
        followeeEvent: (teaserAvailable) => teaserAvailable
            ? 'hat eine neue Veranstaltung erstellt: '
            : 'hat eine neue Veranstaltung erstellt.',
        followeePost: (teaserAvailable) => teaserAvailable
            ? 'hat einen neuen Beitrag erstellt: '
            : 'hat einen neuen Beitrag erstellt.',
        loadingError: 'Die Benachrichtungen konnten nicht geladen werden.',
        newFollower: 'folgt dir jetzt.',
        noneYet: 'Du hast noch keine Benachrichtigungen.',
        notificationBookmark: 'hat auf',
        notificationBookmarkableTypeComment: 'deinen Kommentar',
        notificationBookmarkableTypeEvent: 'deine Veranstaltung',
        notificationBookmarkableTypePost: 'deinen Beitrag',
        notificationComment: 'hat',
        notificationCommented: 'kommentiert.',
        notificationGroupPostEnd: ' erstellt: ',
        notificationGroupPostStart: 'hat einen Beitrag in der Gruppe ',
        notificationMessage: 'hat dir eine neue Nachricht geschrieben.',
        notificationReacted: 'reagiert.',
    },
    onboardingSettings: {
        action: 'Aktion',
        address: 'Adresse',
        addressCorrect: 'Ist die Adresse korrekt?',
        addressStopperText: 'Wenn du umgezogen bist, sende uns bitte eine Nachricht ' +
            'an die folgende E-Mail-Adresse. Wir schicken dann den Umzugswagen los. 🚐',
        adjustYourArea: 'Passe dein Zuständigkeitsgebiet an',
        alreadyExistPhoneNumber: 'Die Telefonnummer kann nicht verwendet werden.',
        backToPost: 'Zurück zum Beitrag',
        birthday: 'Geburtsdatum',
        birthdayFormat: 'TT.MM.JJJJ',
        blockedNeighbors: 'Blockierte Nutzer',
        business: 'Unternehmen & Dienstleister',
        businessDescription: 'Einzelhandel, Handwerk...',
        cannotUseEmailAddress: 'E-Mail-Adresse kann nicht verwendet werden.',
        category: 'Kategorie',
        changeAddress: 'Adresse ändern',
        changePasswordBodyText: 'Klicke einfach unten auf den Button, ' +
            'dann senden wir dir eine E-Mail zum Zurücksetzen deines Passwortes.',
        changePasswordTitle: 'Passwort ändern',
        changeYourPhoto: 'Ändere dein Bild',
        checkYourEmailForUpdatingEmail: 'Bitte bestätige deine E-Mail-Adresse, indem du ' +
            'auf den Link in deiner E-Mail klickst.',
        chooseCategory: 'Bitte wähle eine Kategorie',
        chooseProfile: 'Wie möchtest du mitmachen?',
        collected: 'Gesammelt',
        comments: 'Kommentare',
        completeProfileBody: 'Damit du unsere App nutzen kannst, musst du zuerst dein Profil vervollständigen.\n' +
            'Gehe dafür auf unserer Webseite in deine Einstellungen.',
        completeProfileButton: 'Gehe zu klubly.de',
        completeProfileTitle: 'Du möchtest auch mitreden?',
        connections: 'Verbindungen',
        contactNumber: 'Telefonnummer',
        contactPerson: 'Ansprechpartner',
        contactPersonLopo: 'Miriam von Klubly',
        contactUsEmail: 'info@klubly.de',
        contactUsSubheadline: 'Deine Ansprechpartnerin',
        correctVerificationCode: 'Das hat geklappt! Der eingegebene Bestätigungscode ist korrekt.',
        createProfileStepsHeadline: 'Hereinspaziert',
        dailyUpdateEmailHeadline: 'Neues aus',
        dailyUpdateEmailInfo: (location) => 'Welche neuen Mitglieder gibt\'s eigentlich in deinem ' +
            'Vereinsportal und worüber wird heute geredet. In unserer regelmäßigen E-Mail erfährst du genau das.' +
            '\n\nHier kannst du einstellen, ob wir dich regelmäßig per E-Mail über aktuelle Neuigkeiten aus ' +
            `${location} informieren sollen.`,
        dateFormat: 'TT.MM.JJJJ',
        deleteAccount: 'Nutzerkonto löschen',
        deleteAccountInfo1: 'Wenn du auf „Nutzerkonto löschen“ klickst, werden alle deine Profile mit allen persönlichen ' +
            'Daten und Inhalten (Beiträge, Kommentare, Veranstaltungen), unwiderruflich gelöscht.',
        deleteAccountInfo2: 'Bitte bestätige die Löschung deines Nutzerkontos mit deinem Passwort. ' +
            'Es kann bis zu 30 Tagen dauern, bis all deine Daten restlos gelöscht sind.',
        deleteAccountInfo3: 'Du hast mehrere Profile, möchtest aber nur ein bestimmtes löschen? ' +
            'Dann schreibe uns eine Nachricht an: ',
        deleteAccountPasswordError: 'Gib bitte dein aktuelles Passwort ein.',
        description: 'Vorstellungstext',
        doItLater: 'Das mache ich später',
        dontForgetYourHouseNumber: 'Vergiss deine Hausnummer nicht! ',
        dontMissAnyNews: 'Verpasse keine Neuigkeiten mehr!',
        dontWorryItsNotVisible: 'Keine Sorge! Deine Adresse ist für andere Nutzer nicht sichtbar.',
        emailAddressChange: 'E-Mail-Adresse ändern',
        emailChangeError: 'Es ist ein Fehler beim Ändern der E-Mail-Adresse aufgetreten.',
        emailChangeSuccess: 'Deine E-Mail-Adresse wurde erfolgreich geändert.',
        emailRegistrationError: 'Es ist ein Fehler beim Bestätigen der E-Mail-Adresse aufgetreten.',
        emailRegistrationSuccess: 'Deine E-Mail-Adresse wurde erfolgreich bestätigt.',
        emptyFolloweeListButton: 'Hier geht\'s zur Suche',
        emptyFolloweeListInfo: 'Du hast bisher noch keine Profile abonniert. Schau mal in unserer Suche ' +
            'vorbei, dort findest du viele spannende Profile, denen du folgen kannst. So bleibst du immer ' +
            'über ihre Neuigkeiten auf dem Laufenden.',
        enterCode: 'Gib deinen Bestätigungscode ein',
        extendedOptions: 'Erweiterte Einstellungen',
        facebookRegistrationError: 'Es ist ein Fehler bei der Registrierung aufgetreten.',
        female: 'Weiblich',
        firstLookAround: 'Erstmal stöbern',
        firstLookAroundNow: ' Jetzt erstmal stöbern',
        firstName: 'Vorname',
        firstNameEmpty: 'Bitte gib deinen Vornamen an.',
        followedProfiles: 'Abonnierte Profile',
        further: 'Weitere',
        furtherSettings: 'Weitere Einstellungen',
        giveYourContactNumber: 'Gib deine Kontaktnummer an (optional)',
        giveYourContactPerson: 'Gib einen Ansprechpartner an',
        giveYourImpressum: 'Gib dein Impressum an (optional)',
        giveYourInternetSite: 'Wie lautet deine Internetseite (optional)',
        hiddenNeighbors: 'Verborgene Mitglieder',
        iHaveAlreadyCode: 'Ich habe schon einen Code',
        immediately: 'Sofort',
        infocardAddressTitle: 'Neuigkeiten aus dem Verein',
        infocardDateOfBirthBody: 'Die Angabe deines Geburtsdatums ist freiwillig. ' +
            'Dein Geburtstag ist für andere Mitglieder nicht zu sehen.',
        infocardDateOfBirthTitle: 'Nur wenn du möchtest ...',
        infocardNameBody: 'Echte Nutzer mit echten Namen führen zu einem viel netteren Umgang ' +
            'und einem vertrauensvollen Austausch in deinem Vereinsportal. ' +
            'Deine Vereinsportal-Mitglieder freuen sich, wenn sie wissen, mit wem sie sich unterhalten.',
        infocardNameTitle: 'Wer ist denn dieser Hans Wurst?',
        internetSite: 'Internetseite',
        internetSiteError: 'Die Internetseite ist nicht gültig',
        introduceYouToYourNeighbor: 'Stelle dich deinen Vereinsfreunden vor (optional)',
        invalidName: 'Es müssen zwei Buchstaben aufeinanderfolgen.',
        invalidPhoneNumber: 'Die Telefonnummer ist nicht gültig',
        invalidVerificationCode: 'Der Bestätigungscode ist nicht gültig',
        lastAttempt: 'Du hast noch einen Versuch!',
        lastName: 'Nachname',
        lastNameEmpty: 'Bitte gib deinen Nachnamen an.',
        letsGo: 'Leg gleich los!',
        letterNotReceived: 'Du hast deine Adresse richtig angegeben, aber noch keine Post ' +
            'von uns erhalten? Dann schreibe uns bitte eine Nachricht an: ',
        male: 'Männlich',
        mutedProfiles: 'Stumm geschaltete Profile',
        myInterests: 'Meine Interessen',
        myInterestsInfo: 'Gib deine Interessen an und finde Gleichgesinnte, mit denen du dich ' +
            'über deine Lieblingsthemen austauschen kannst. Dein Interesse ist noch nicht dabei? ' +
            'Sende uns deinen Vorschlag gleich als ',
        name: 'Name',
        neighbor: 'Nutzerprofil',
        neighborDescription: 'Für Vereinsmitglieder, Freunde und Interessierte',
        newEmailAddress: 'Neue E-Mail-Adresse',
        newProfile: 'Neues Profil erstellen',
        newProfileInfo: 'Möchtest du ein weiteres Profil erstellen? ' +
            'Wähle aus, ob du ein privates oder ein Partnerprofil erstellen möchtest.',
        newsletter: 'Newsletter',
        newsletterInfo: 'In unserem Newsletter halten wir dich über interessante Beiträge aus ' +
            'deinem Verein, über Aktionen und neue Funktionen auf dem Laufenden.\n\nHier kannst du ' +
            'einstellen, ob du diese E-Mails regelmäßig erhalten möchtest.',
        noAlwaysEditable: 'Nein (jederzeit änderbar)',
        notAvailableMessage: 'Einige Einstellungen konnten nicht geladen werden.',
        notSavedCorrectly: 'Das Speichern hat nicht geklappt',
        notifications: 'Benachrichtigungen',
        organisation: 'Organisation',
        organisationDescription: 'Verein',
        other: 'Andere',
        phone: 'Telefonnummer',
        post: 'Brief',
        postCardSend: 'Du bekommst Post!',
        postCardSendInfo1: 'Wir senden dir einen Brief an ',
        postCardSendInfo2: '. Er sollte innerhalb von 7 Tagen bei dir sein.',
        postCardWaring: 'Damit unser Brief bei dir ankommt, gib bitte deine vollständige Adresse an. ' +
            'Achte darauf, dass du deine Hausnummer nicht vergessen hast.',
        profile: 'Profil',
        profileDescriptionPlaceholder: 'Stelle dich deinem Verein vor.',
        profileName: 'Profilname',
        profilePicture: 'Profilbild',
        profileSetting: 'Profil Einstellungen',
        profileTypeAssociation: 'Organisation',
        profileTypeBlogger: 'Öffentliche Person',
        profileTypeBusiness: 'Gewerbe',
        publicPerson: 'Öffentliche Personen',
        publicPersonDescription: 'Blogger, Autoren, Künstler...',
        publicProfile: 'Partnerprofil',
        publicProfileChoice: 'Für Partner & Sponsoren',
        publicProfileContent: 'Wir helfen bei der Erstellung eines öffentlichen Profils. ' +
            'Bitte tritt als Ansprechpartner einer öffentlichen Stelle direkt mit uns in Kontakt.',
        publicProfileDescription: 'Ämter, Polizei, Feuerwehr...',
        publicProfileHeader: 'Verein',
        publisher: 'Verein',
        publisherDescription: 'Verein...',
        reactions: 'Reaktionen',
        regularyEmails: 'Regelmäßige E-Mails',
        requestVerification: 'Bestätigungscode anfordern',
        responsibilityArea: 'Zuständigkeitsgebiet',
        responsibilityAreaContent: 'Wir helfen bei Fragen oder Änderungswünschen jederzeit gerne',
        returnToLogin: 'Zurück zur Anmeldung',
        securityIsImportant: 'Sicher ist sicher',
        selectCategories: 'Wähle bis zu 3 Rubriken',
        sendMeCodeWithPost: 'Sendet mir einen Code per Brief',
        sendMeCodeWithSMS: 'Sendet mir einen Code per SMS',
        sentMail: 'Wir haben dir die Bestätigungsmail noch einmal gesendet.',
        sms: 'SMS',
        smsCodePending: 'Wir haben dir eine SMS mit einem Bestätigungscode gesendet.',
        smsInfoMail: 'info@klubly.de',
        smsInfoText1: 'Wenn du eine falsche Nummer angegeben hast, schreibe uns bitte eine Nachricht an ',
        smsInfoText2: ', damit du deine Registrierung abschließen kannst.',
        smsVerificationCode1: 'Wir haben dir eine SMS mit einem Bestätigungscode an ',
        smsVerificationCode2: ' gesendet.',
        smsVerificationCode3: 'Du hast keine SMS erhalten? Bitte ',
        smsVerificationCode4: 'versuche es hier noch einmal.',
        smsVerificationNoAttempts1: 'Upsi... das war dein letzter Versuch. Aber keine Sorge! Schreibe uns einfach eine' +
            ' Nachricht an ',
        smsVerificationNoAttempts2: ' und wir helfen dir weiter.',
        smsVerificationNoAttempts3: 'Alternativ schicken wir dir gerne einen Bestätigungscode per Post.',
        splashNewsletterMessage: 'Möchtest du, dass wir bzw. unsere Partner dich regelmäßig ' +
            'per E-Mail über neue Beiträge informieren?',
        splashSuccessAssociation: 'Stelle dich deinem Verein vor und teile aktuelle Neuigkeiten.',
        splashSuccessBlogger: 'Begrüße deine Vereinsfreunde und stelle dich vor.',
        splashSuccessBusiness: 'Stelle dich deinem Vereinsportal vor und mache auf Aktionen und Angebote aufmerksam.',
        splashSuccessPrivate: 'Stelle dich deinem Vereinsportal vor und teile aktuellen Neuigkeiten.',
        toBriefVerification: 'Zur Briefverifizierung',
        uploadYourPhoto: 'Lade ein Bild hoch (optional)',
        verification: 'Verifizierung',
        verificationCode: 'Bestätigungscode',
        verified: 'Verifiziert',
        verifyYourVerificationCode: 'Damit wir sicherstellen können, dass du ein echter ' +
            'Nutzer bist, verifiziere dich bitte mit einem Bestätigungscode.',
        viewCountNotify: 'Impressionen',
        weNeedYourAddress: 'Damit wir dich deinem Verein zuordnen können, ' +
            'benötigen wir deine Adresse. ',
        welcomeToLopo: 'Willkommen in deinem Vereinsportal!',
        welcomeToNeighborhood: 'Willkommen in deinem Vereinsportal',
        whatIsYourName: 'Wie heißt du?',
        whatIsYourProfileName: 'Wie soll dein Profil heißen?',
        writeAPost: 'Schreibe deinen ersten Beitrag',
        youCanDeleteAccount: 'Hier kannst du dein Nutzerkonto löschen',
        youGotEmail: 'Du hast Post!',
        yourAddress: 'Deine Adresse',
        yourAddressIsNotPublic: 'Deine Adresse ist nicht öffentlich sichtbar',
        yourAddressIsPublic: 'Adresse deines öffentlichen Profils',
    },
    pageTitles: {
        addProfile: 'Profil hinzufügen',
        eventParticipants: 'Teilnehmerliste',
        eventParticipatingFeed: 'Veranstaltungen',
        eventfeed: 'Veranstaltungen für ',
        eventfeedSimple: 'Veranstaltungen',
        events: 'Veranstaltungen: ',
        followers: 'Abonnenten',
        for_: ' für ',
        groupFeed: (groupName) => `Gruppe: ${groupName}`,
        groupOverview: 'Gruppen',
        inbox: 'Postfach',
        locationPicker: 'Region auswählen',
        newsfeed: 'Aktuelles für ',
        newsfeedSimple: 'Aktuelles',
        notifications: 'Benachrichtigungen',
        profile: 'Profil',
        profileSearch: 'Suche für ',
        profileSearchSimple: 'Suche',
        recentFolloweesFeed: 'Profilbeiträge',
        recentGroupsFeed: 'Gruppenbeiträge',
        resetPassword: 'Passwort zurücksetzen',
        settings: 'Einstellungen',
        shapeSponsors: 'Partner',
        signIn: 'Anmelden',
    },
    postCreate: {
        addEndDate: 'Enddatum hinzufügen',
        addEventCategory: 'Bitte wähle eine Kategorie aus',
        addPictureActionSheetHeader: 'Füge ein Foto hinzu',
        addressSubmenuTitle_APP: 'Adresse oder Ort',
        addressSubmenuTitle_WEB: 'Adresse',
        cameraPermissionErrorBody: 'Erlaube uns zuerst den Zugriff auf deine Kamera. ' +
            'Gehe dafür in deine Einstellungen.',
        cameraPermissionErrorTitle: 'Dein Vereinsportal hat keinen Zugriff auf deine Kamera',
        cameraRoll: 'Galerie',
        campaignAddOffer: 'Stelle deine aktuellen Angebote vor',
        campaignBillingButton: 'Beitrag kostenpflichtig bewerben',
        campaignBillingHeadline: 'Überblick',
        campaignBillingTermsOfUse: 'Ich bestätige die ',
        campaignBillingText1: 'Wir schicken dir eine Rechnung an die Adresse, die du bei der Anmeldung in deinem Profil ' +
            'angegeben hast.\nMit einem Klick auf den Button wird dein Beitrag in dem Vereinsportal veröffentlicht und mit ',
        campaignBillingText2: ' für 24 Stunden auf Facebook, Instagram und Google beworben.',
        campaignBillingTitle: 'Bezahlung',
        campaignDeletePostTooltip: 'Anzeigen können nicht gelöscht werden.',
        campaignError: 'Dieser Vorgang konnte leider nicht ausgeführt werden.',
        campaignErrorDeletePost: 'Beitrag löschen',
        campaignErrorHeadline: 'Fehler',
        campaignErrorKeepPost: 'Beitrag behalten',
        campaignErrorText1: 'Dein Beitrag wurde veröffentlich, konnte aber leider nicht beworben werden. Solange ' +
            'er nicht erfolgreich beworben wurde, stellen wir dir die Werbekosten natürlich nicht in Rechnung. Versuche ' +
            'es einfach noch einmal! Du kannst deinen Beitrag auch behalten, ohne ihn zu bewerben oder ihn löschen.',
        campaignErrorText2: 'Wenn du Fragen hast, schreibe uns gerne ein Nachricht an ',
        campaignErrorTryAgain: 'Beitrag bewerben',
        campaignIntroDuration: '24 Stunden',
        campaignIntroFooter: 'Weitere Informationen zur Werbeanzeige findest du in den ',
        campaignIntroHeadline: 'Erreiche die Menschen, die für dein Gewerbe wichtig sind',
        campaignIntroSocialMeda: 'Social Media Kanälen',
        campaignIntroTermsOfUse: 'Nutzungsbedingungen',
        campaignIntroText1: 'Bewirb deine aktuellen Angebote und Dienstleistungen schnell und einfach mit einer ' +
            'Werbeanzeige und hole die Menschen aus deinem Verein direkt in dein Geschäft.',
        campaignIntroText2_1: 'Dein Beitrag wird nicht nur in deinem Vereinsportal veröffentlicht, sondern für ',
        campaignIntroText2_2: ' auf den bekannten ',
        campaignIntroText2_3: ' beworben – und das für nur ',
        campaignIntroText3: 'So erreichst du deine Kunden, egal wo sie gerade sind.',
        campaignPreviewTitle: 'Vorschau',
        campaignSubmitting: 'Beitrag bewerben',
        campaignSuccessButtonNewsfeed: 'Zurück zum Newsfeed',
        campaignSuccessButtonPost: 'Beitrag anzeigen',
        campaignSuccessHeadline1: 'Super, das hat geklappt!',
        campaignSuccessHeadline2: 'Du willst noch mehr Reichweite?',
        campaignSuccessText1: 'Dein Beitrag wird veröffentlicht und für 24 Stunden auf Facebook, Instagram und Google ' +
            'beworben.',
        campaignSuccessText2: 'Vielen Dank für deine Bestellung!',
        campaignSuccessText3: 'Teile deinen Beitrag!',
        campaignSuccessTitle: 'Bestätigung',
        campaignWarningText1: 'Nachdem du deine Werbeanzeige kostenpflichtig beworben hast, kannst du sie nur noch auf ',
        campaignWarningText2: ' bearbeiten. Auf Facebook, Instagram und Google kann deine Anzeige im Nachhinein nicht ' +
            'mehr angepasst werden.',
        campaignWarningText3: 'Werbeanzeigen können nachträglich nicht mehr gelöscht werden',
        campaignWarningTitle: 'Achtung!',
        campaignWriteMedia: 'Was wäre deine Anzeige ohne ein ansprechendes Bild?',
        cancelMessage: 'Dein Beitrag ist noch nicht fertig. Möchtest du das Fenster wirklich verlassen, ' +
            'ohne deinen Beitrag fertig zu schreiben?',
        cancelTitle: 'Möchtest du das Fenster verlassen?',
        closeWindow: 'Fenster verlassen',
        commentsTitle: 'Kommentare erlauben?',
        continueWritingPost: 'Beitrag weiterschreiben',
        createEventSubtitle: '... und schon steht sie im Kalender',
        createEventTitle: 'Erstelle eine Veranstaltung',
        createPostSubtitle: 'Teile es mit deinem Verein!',
        createPostTitle: 'Was gibt\'s Neues?',
        descriptionIsMissing: 'Bitte gib eine Beschreibung ein.',
        descriptionOptionalPlaceholder: 'Beschreibung (optional)',
        descriptionPlaceholder: 'Teile Neuigkeiten mit deinem Verein',
        endDate: 'Enddatum',
        endDateRequired: 'Bitte gib ein Enddatum an.',
        endDateShouldNotBeforeStartDate: 'Das Enddatum darf nicht vor dem Anfangsdatum liegen.',
        endTime: 'Endzeit',
        endTimeNotInThePast: 'Sag nicht, du kannst in die Vergangenheit reisen?! 😱',
        endTimeRequired: 'Bitte gib eine Endzeit an',
        eventDescriptionPlaceholder: 'Beschreibung',
        flagPost: 'Beitrag melden',
        guideText: 'Halte deinen Verein auf dem Laufenden! Teile Neuigkeiten mit ' +
            'und veröffentliche Bilder, die dir gefallen.',
        guideTextCampaign: 'Erstelle jetzt eine Werbeanzeige und erziele noch mehr Reichweite!',
        guideTextNew: 'Jetzt neu:',
        guideTitle: 'Was möchtest du tun?',
        headerCategory: 'Kategorie',
        headerDate: 'Datum',
        headerPosition: 'Ort',
        headerPreview: 'Vorschau',
        imageCropperButtonBigger: 'größer',
        imageCropperButtonRotate: 'drehen',
        imageCropperButtonSmaller: 'kleiner',
        imageCropperButtonTitleImage: 'Titelbild',
        imageCropperTitle: 'Bild bearbeiten',
        imageGalleryPermissionErrorBody: 'Erlaube uns zuerst den Zugriff auf deine Galerie. ' +
            'Gehe dafür in deine Einstellungen.',
        imageGalleryPermissionErrorTitle: 'Dein Vereinsportal hat keinen Zugriff auf deine Fotos und Videos',
        imageSelectionErrorBody: 'Beim Hinzufügen des Fotos ist ein Fehler aufgetreten.',
        lessThanThreeDays: 'Eine Veranstaltung darf nicht länger als 3 Tage dauern.',
        mediaDeleteButton: 'Bild löschen',
        mediaMaxImages: (maxImages) => `max. ${maxImages} Bilder`,
        mediaMaxImagesError: (maxImages) => `Du kannst leider nicht mehr als ${maxImages} Bilder hochladen.`,
        mediaMaxImagesGenericError: 'Du kannst leider nicht mehr Bilder hochladen.',
        mediaPermissionErrorBody: 'Erlaube uns zuerst den Zugriff auf deine Kamera und Galerie. ' +
            'Gehe dafür in deine Einstellungen.',
        mediaPermissionErrorTitle: 'Dein Vereinsportal hat keinen Zugriff auf deine Medien',
        mediaSelectSubtext: 'Jetzt hinzufügen',
        mediaSelectText: 'Verschönere deinen Beitrag mit Bildern.',
        mediaTitle: 'Fotos',
        moreMediaPlural: 'weitere Bilder',
        moreMediaSingular: 'weiteres Bild',
        postSubmitting: 'Dein Beitrag wird veröffentlicht.',
        previewLoadingError: 'Die Vorschau konnte nicht geladen werden.',
        previewMessage: (location) => `Dein Beitrag ist in ${location} sichtbar.`,
        previewText: 'Bist du damit zufrieden?',
        removeEndDate: 'Enddatum entfernen',
        removePreviewLink: 'Link-Vorschau entfernen',
        selectSubtitleCampaign: 'Beitrag mit erhöhter Reichweite',
        selectSubtitleEvent: 'Öffentliches Event oder Treffen',
        selectSubtitlePublicPost: 'Öffentlich sichtbarer Beitrag',
        selectSubtitleSnapshot: 'Fotoformat für alle Bilder',
        selectSubtitleSurvey: 'Erstelle eine Umfrage',
        selectTitlePublicPost: 'Beitrag',
        shareYourInformation: 'Verbreite deine aktuellen Informationen',
        snapshotLocationBody: 'Zeige deinen Vereinsfreunden, wo dein Schnappschuss entstanden ist, ' +
            'damit sie diesen Ort auch besuchen können.',
        snapshotLocationTitle: 'Wo hast du dein Foto gemacht?',
        startDate: 'Anfangsdatum',
        startDateRequired: 'Bitte gib ein Anfangsdatum ein.',
        startDateShouldNotBeThePast: 'Die Veranstaltung muss in der Zukunft liegen.',
        startTime: 'Anfangszeit',
        startTimeRequired: 'Bitte gib eine Anfangszeit ein.',
        surveyAnswersTitle: 'Antwortmöglichkeiten',
        surveyCreateButton: "Erstelle eine Umfrage",
        surveyDatepickerPlaceholder: "Datum auswählen",
        surveyDatepickerTitle: "Enddatum festlegen",
        surveyOption: (index) => `Option ${index}`,
        surveyOptionAdd: "Antwortmöglichkeit hinzufügen",
        surveyQuestionPlaceholder: "Überschrift",
        surveyQuestionTitle: "Frage",
        surveySubmitting: 'Deine Umfrage wird veröffentlicht.',
        takePicture: 'Foto aufnehmen',
        titleIsMissing: 'Bitte gib einen Titel ein.',
        titlePlaceholder: 'Überschrift',
        whereToPin: 'Wo soll dein Pin auf der Karte sitzen?',
        writeTitleCampaign: 'Werbeanzeige',
    },
    postDetail: {
        relatedContentSubtitle: 'Das könnte dich auch interessieren',
        relatedContentTitle: 'Weitere Beiträge',
        source: 'Quelle',
        tickets: 'Tickets',
    },
    postTypes: {
        event: 'Veranstaltung',
        groupPost: 'Gruppenbeitrag',
        publicPost: 'Beitrag',
        snapshot: 'Schnappschuss',
        survey: 'Umfrage',
    },
    premiumContentInfo: {
        body: 'Du möchtest alle Beiträge im Vereinsportal lesen? Registriere dich einfach kostenlos.',
        bodyTitle: 'Mach mit und werde Teil deines Vereinsportals!',
        bullet1: 'Erhalte exklusive Neuigkeiten von deinem Verein',
        bullet2: 'Tausche dich mit deinen Vereinsfreunden aus',
        bullet3: 'Endecke Veranstaltungen',
        title: 'Kostenlos weiterlesen',
    },
    profile: {
        aboutMe: 'Über mich:',
        authorityProfile: 'Verifiziertes Profil',
        blogProfile: 'Seite',
        blurredLoggedOutBody: 'Das Schöne am gegenseitigen Kennenlernen ist ja, dass dazu immer zwei gehören. \n' +
            'Profile von Nutzern kannst du deshalb nur sehen, ' +
            'wenn du dich bei deinem Vereinsportal registriert hast.',
        blurredLoggedOutBodyTile: (profileName) => `Du möchtest ${profileName} besser kennenlernen?`,
        editProfile: 'Profil bearbeiten',
        extensionAuthority: 'Partner & Sponsoren',
        extensionBlog: 'Partner & Sponsoren',
        extensionPress_APP: 'Dein Verein',
        extensionPress_WEB: 'Dein Verein',
        extensionPrivate: 'Community',
        extensionUnknown: '',
        giveYourInterests: 'Gib deine Interessen an und finde Gleichgesinnte, mit denen ' +
            'du dich zu bestimmten Themen austauschen kannst.',
        myInterests: 'Meine Interessen:',
        neighborFromFemale: 'Nutzerin',
        neighborFromMale: 'Nutzer',
        pressProfile: 'Abteilungen',
    },
    profileList: {
        orderBy: 'Sortiert nach:',
        orderByAccessionDate_APP: 'Beitrittsdatum',
        orderByAccessionDate_WEB: 'Beitrittsdatum (neueste zuerst)',
        orderByName: 'Name',
        orderDirectionAscendingDate: 'älteste zuerst',
        orderDirectionAscendingName: 'aufsteigend',
        orderDirectionDescendingDate: 'neueste zuerst',
        orderDirectionDescendingName: 'absteigend',
    },
    profileSearch: {
        relatedContentSubtitle: 'Das könnte dich auch interessieren.',
        searchAndDiscover: 'Suchen und entdecken',
    },
    pushNotification: {
        permissionAlertBody: 'Wenn du Benachrichtigungen erlaubst, verpasst du keine Neuigkeiten mehr von ' +
            'deinem Verein. In den Einstellungen kannst du sie jederzeit ausschalten.',
        permissionAlertCancelAction: 'Nicht erlauben',
        permissionAlertPositiveAction: 'Erlauben',
        permissionAlertTitle: 'Push-Benachrichtigungen',
    },
    rateTheApp: {
        addRating: 'Bewertung abgeben',
        doYouLikeLopo: 'Gefällt dir dein Vereinsportal?',
        no: 'Nein',
        notYet: 'Nicht jetzt',
        rateTheAppBody: 'Bewerte die App im Google Play Store.',
        rateTheAppTitle: 'Juhu! Dann freuen wir uns über deine Bewertung.',
        yes: 'Ja',
    },
    reactions: {
        condolences: 'Mein Beileid',
        countInfo: (profileName, count) => {
            const maxCharacters = 14;
            let truncatedName = profileName;
            if (profileName.length > maxCharacters) {
                truncatedName = profileName.substring(0, maxCharacters) + '...';
            }
            switch (count) {
                case 1:
                    return profileName;
                case 2:
                    return `${truncatedName} und 1 weiterer Nutzer`;
                default:
                    return `${truncatedName} und ${count - 1} weitere Nutzer`;
            }
        },
        emptyReactions: 'Es gibt bisher noch keine Reaktionen auf diesen Beitrag.',
        haha: 'Lustig',
        interesting: 'Interessant',
        like: 'Mag ich',
        ohNo: 'Traurig',
        reactions: 'Reaktionen',
        title: 'Wie findest du diesen Beitrag?',
        wow: 'Wow',
    },
    relatedContent: {
        headline: 'Weitere Beiträge',
        subHeadline: 'Das könnte dich auch interessieren',
    },
    reloadPage: {
        message: 'Es gibt eine neue Version deines Vereinsportals. Bitte lade die Seite neu, ' +
            'damit du das Portal weiter nutzen kannst.',
        reload: 'Neu laden',
    },
    screenReaderText: {
        addMorePictures: 'Weitere Bilder hinzufügen',
        administrator: 'Administrator',
        close: 'Schließen',
        closeChat: 'Chat schließen',
        closeMap: 'Karte schließen',
        message: 'Nachrichten',
        moreOptions: 'Mehr Optionen',
        new: ' neue ',
        nextDay: 'Nächster Tag',
        nextMonth: 'Nächster Monat',
        nextYear: 'Nächstes Jahr',
        notification: 'Benachrichtigungen',
        openCalendar: 'Kalender öffnen',
        openChat: 'Chat öffnen',
        openMap: 'Karte öffnen',
        openMenu: 'Menü öffnen',
        photoGallery: 'Fotogallerie',
        previousDay: 'Vorheriger Tag',
        previousMonth: 'Vorheriger Monat',
        previousYear: 'Vorheriges Jahr',
        stepCompleted: 'Schritt abgeschlossen',
        titlePicture: 'Titelbild',
        viewMessage: 'Nachricht ansehen',
    },
    shapeSponsors: {
        bronzePartner: 'Partner',
        formBody: 'Dein Profil soll auch im Mittelpunkt stehen? Als Partner erscheint dein Profilbild ' +
            'ganz oben auf unserer Startseite und wird optisch hervorgehoben. Du erhältst so ganz einfach ' +
            'noch mehr Sichtbarkeit.\n\n' +
            'Du möchtest Partner werden oder hast noch Fragen? Schreibe uns eine kurze Nachricht und unser ' +
            'Team meldet sich so schnell wie möglich bei dir. Wenn du möchtest, schreib gerne deine Telefonnummer ' +
            'dazu, dann geht\'s noch schneller. ☎',
        formSuccessBody: 'Wir melden uns so schnell wie möglich bei dir!',
        formSuccessTitle: 'Deine Nachricht ist auf dem Weg',
        formTitle: 'Werde Partner!',
        inputErrorText: 'Bitte gib deine Nachricht ein.',
        inputPlaceholder: 'Deine Nachricht',
        silverPartner: 'Premium Partner',
        title: 'Partner',
    },
    share: {
        email: 'E-Mail',
        facebook: 'Facebook',
        greeting: 'Kennst du schon das Vereinsportal für deinen Sportverein?\n' +
            'Ich tausche mich dort schon mit meinen Vereinsfreunden aus. ' +
            'Mach auch mit und registriere dich jetzt kostenlos auf \n',
        link: 'Link',
        linkWasCopiedToClipboard: 'Der Link wurde in die Zwischenablage kopiert.',
        share: 'Teilen',
        subject: 'Ich möchte dich in unser Vereinsportal einladen!',
        twitter: 'Twitter',
        whatsapp: 'WhatsApp',
    },
    shared: {
        aboutUs: 'Über uns',
        addInterests: 'Interessen hinzufügen',
        and: 'und',
        back: 'Zurück',
        blog: 'Blog',
        cancel: 'Abbrechen',
        close: 'Schließen',
        continue: 'Weiter',
        delete: 'Löschen',
        done: 'Fertig',
        edit: 'Bearbeiten',
        email: 'E-Mail-Adresse',
        emptyFeedText: 'Hier gibt es bisher leider noch keine Beiträge.',
        emptyListText: 'Hier gibt es derzeit leider nichts interessantes zu sehen.',
        errorEmail: 'Bitte überprüfe deine E-Mail-Adresse.',
        errorUnknown: 'Ups... da ist was schiefgelaufen.',
        faq: 'FAQ',
        feedback: 'Feedback',
        forMe: 'Für mich',
        formAssistiveText: 'Trenne mehrere Adressen bitte durch Kommata.',
        formErrorInvalid: 'Da hat sich ein Fehler eingeschlichen',
        genericErrorBody: 'Bei der letzten Aktion ist etwas schiefgelaufen.',
        genericErrorLong: 'Ups... da ist etwas schiefgelaufen.\nVersuche es bitte noch einmal.',
        genericErrorTitle: 'Ups...',
        helpEmail: 'info@klubly.de',
        hereIsMore: 'Hier gibt\'s noch mehr!',
        imageAddError: 'Huch... beim Hinzufügen eines Bildes ist ein Fehler aufgetreten!',
        imprint: 'Impressum',
        inputTooShort: (minCharacters) => `Bitte gib mindestens ${minCharacters === 1 ? 'ein' : minCharacters} Zeichen ein.`,
        jobs: 'Jobs',
        learnMore: 'Mehr über dein Vereinsportal',
        login: 'Anmelden',
        logout: 'Abmelden',
        lokalportal: 'Vereinsportal',
        lokalportalSite: 'klubly.de',
        maxCharacters: (maxCharacters) => `max. ${maxCharacters} Zeichen`,
        neighborhood: 'Verein',
        never: 'Nie',
        newVersion: 'Eine neue Version ist verfügbar',
        noLocalResultFound: 'Leider konnten keine Ergebnisse gefunden werden.',
        noResultFound: 'Leider konnten keine Ergebnisse gefunden werden.',
        ok: 'OK',
        or: 'oder',
        pageNotFound: 'Oh je... der Beitrag konnte leider nicht gefunden werden.',
        paginationButtonTitle: (page) => `Seite ${page}`,
        password: 'Passwort',
        period: '.',
        privacy: 'Datenschutz',
        register: 'Registrieren',
        registerNow: 'Jetzt registrieren',
        required: '*Pflichtfeld',
        retry: 'Noch einmal versuchen',
        save: 'Speichern',
        sayHello: 'Sag Hallo!',
        send: 'Senden',
        settings: 'Einstellungen',
        showAll: 'Alle anzeigen',
        submit: 'Absenden',
        terms: 'AGB',
        understood: 'Verstanden',
        verify: 'Verifizieren',
        version: 'Version',
        welcomeBack: 'Willkommen zurück',
        writeMessage: 'Nachricht schreiben',
        yes: 'Ja',
    },
    spread: {
        formFieldEmailsPlaceholder: 'E-Mail-Adresse(n)',
        formFieldMessagePlaceholder: 'Dein Einladungstext',
        formFieldSenderPlaceholder: 'Dein Name',
        formIntro: 'Erzähle deinen Freunden und Bekannten vom Vereinsportal. Je mehr Nutzer dabei sind, ' +
            'desto mehr Schwung kommt in die Bude.',
        formOptional: 'Optional',
        formSubmitButton: 'Einladung abschicken',
        formTitle: 'Sind deine Freunde schon an Bord?',
        shareIntro: 'Teile das Vereinsportal mit deinen Freunden:',
        thanksMessage: 'Deine Einladung wurde verschickt. Wir freuen uns, dass du dabei hilfst, ' +
            'unser Vereinsportal noch lebendiger zu machen. 🤗',
        thanksTitle: 'Super, das hat geklappt!',
    },
    welcomeScreen: {
        backtoPost: 'Zurück zum Beitrag',
        completeProfileSubtitle: 'Zeig deine Schokoladenseite',
        completeProfileTitle: 'Profil vervollständigen',
        followProfilesSubtitle: 'Verpasse keine Neuigkeiten',
        followProfilesTitle: 'Profilen folgen',
        headerTitle: 'Willkommen',
        joinGroupsSubtitle: 'Finde Gruppen in deiner Nähe',
        joinGroupsTitle: 'Gruppen beitreten',
        title: 'Entdecke unser Vereinsportal.',
    },
    wizard: {
        request: 'Anfordern',
        send: 'Senden',
        start: 'Jetzt starten',
    },
};
